/**
 * Sidebar Component — Lucide icons, collapsible nav
 */
import React from 'react';
import {
    LayoutDashboard,
    FileText,
    BarChart3,
    Users,
    Settings,
    LogOut,
    BrainCircuit,
    PanelLeftClose,
    PanelLeftOpen,
} from 'lucide-react';

const NAV_ITEMS = [
    { id: 'overview', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'surveys', label: 'Studies', icon: FileText },
    { id: 'divider-1', divider: true },
    { id: 'reports', label: 'Reports', icon: BarChart3 },
    { id: 'leadership', label: 'Leadership', icon: Users },
    { id: 'divider-2', divider: true },
    { id: 'settings', label: 'Settings', icon: Settings },
];

function Sidebar({ activeView, onNavigate, adminUser, onLogout, collapsed, onToggleCollapse }) {
    return (
        <aside className={`ds-sidebar ${collapsed ? 'collapsed' : ''}`}>
            {/* Brand — click to toggle */}
            <div className="ds-sidebar-brand" onClick={onToggleCollapse} title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
                <div className="ds-brand-icon">
                    <BrainCircuit size={18} />
                </div>
                <div className="ds-brand-text">
                    <span className="ds-brand-name">Work Study AI</span>
                    <span className="ds-brand-tagline">Workforce Analytics</span>
                </div>
            </div>

            {/* Navigation */}
            <nav className="ds-sidebar-nav">
                {NAV_ITEMS.map(item =>
                    item.divider ? (
                        <div key={item.id} className="ds-nav-divider" />
                    ) : (
                        <button
                            key={item.id}
                            className={`ds-nav-item ${activeView === item.id ? 'active' : ''}`}
                            onClick={() => onNavigate(item.id)}
                            title={collapsed ? item.label : undefined}
                        >
                            <item.icon size={20} />
                            <span>{item.label}</span>
                        </button>
                    )
                )}
                {/* Collapse toggle at bottom of nav */}
                <div className="ds-nav-divider" />
                <button className="ds-nav-item" onClick={onToggleCollapse} title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
                    {collapsed ? <PanelLeftOpen size={20} /> : <PanelLeftClose size={20} />}
                    <span>{collapsed ? 'Expand' : 'Collapse'}</span>
                </button>
            </nav>

            {/* User footer */}
            <div className="ds-sidebar-footer">
                <div className="ds-user-avatar" title={collapsed ? (adminUser?.username || 'Admin') : undefined}>
                    {(adminUser?.username || 'A').charAt(0).toUpperCase()}
                </div>
                <div className="ds-user-info">
                    <div className="ds-user-name">{adminUser?.username || 'Admin'}</div>
                    <div className="ds-user-role">Administrator</div>
                </div>
                <button className="ds-logout-btn" onClick={onLogout} title="Sign out">
                    <LogOut size={18} />
                </button>
            </div>
        </aside>
    );
}

export default Sidebar;
